import "./App.css";
import React, { lazy, Suspense } from "react";
import { FaJsfiddle } from "react-icons/fa";
// import { render } from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const Main = lazy(() => import("./components/Main"));
const NotFound = lazy(() => import("./components/NotFound"));

const renderLoader = () => (
  <div className="text-center min-h-screen bg-primary items-center flex place-content-center place-items-center mx-auto text-white">
    <FaJsfiddle />
    <span className="px-1">Processing...</span>
  </div>
);

// Greeting
const hour = new Date().getHours();
let greeting;
if (hour < 10) {
  greeting = "🌅 Good Morning, Dev";
} else if (hour < 14) {
  greeting = "🌤️ Good Day, Dev";
} else if (hour < 18) {
  greeting = "🌇 Good Afternoon, Dev";
} else {
  greeting = "🌙 Good Night, Dev";
}
console.log(greeting);

const App = () => (
  <Suspense fallback={renderLoader()}>
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route component={NotFound} />
      </Switch>
    </Router>
  </Suspense>
);

export default App;

// import React from "react";
// import Webpages from "./blog";
// function App() {
//   return (
//     <div>
//       <Webpages />
//     </div>
//   );
// }
// export default App;



// WEBPACK FOOTER //
// ./src/App.js